<template>
  <Breadcrumb :items="breadcrumbs" />
  <Loading v-if="loading" />
  <div v-else-if="post" class="ds-page">
    <div class="ds-container">
      <div class="ds-page-header">
        <div>
          <h1 class="ds-page-header__title">{{ post.title }}</h1>
          <p class="ds-page-header__subtitle">
            <span v-if="post.category" class="badge-pill">{{ post.category.title }}</span>
            <span class="status-badge ms-2" :class="post.is_published ? 'status-badge--accepted' : 'status-badge--pending'">
              {{ post.is_published ? 'منشور' : 'مسودة' }}
            </span>
          </p>
        </div>
        <div class="ds-page-header__actions">
          <router-link :to="`/blog/edit/${post.id}`" class="ds-btn ds-btn--primary">
            <i class="pi pi-pencil"></i> تعديل
          </router-link>
        </div>
      </div>

      <img v-if="post.featured_image_link" :src="post.featured_image_link" :alt="post.title" class="post-hero" />

      <div class="post-content" v-html="post.content"></div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import Loading from '@/components/global/loading.vue';
import { useBlogStore } from '@/stores/useBlogStore.js';

export default {
  name: 'BlogShow',
  components: { Breadcrumb, Loading },
  data() {
    return {
      postId: this.$route.params.id,
      post: null,
      loading: true,
    };
  },
  computed: {
    store() { return useBlogStore(); },
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: 'المدونة', path: '/blog' },
        { name: this.post?.title || 'مقال', path: `/blog/${this.postId}` },
      ];
    },
  },
  async mounted() {
    this.loading = true;
    this.post = await this.store.fetchPost(this.postId);
    this.loading = false;
  },
};
</script>

<style scoped>
.post-hero { width: 100%; max-height: 420px; object-fit: cover; border-radius: var(--radius-lg); margin: 1.5rem 0; }
.post-content { line-height: 1.9; color: var(--text-primary); font-size: 1rem; }
.post-content :deep(img) { max-width: 100%; border-radius: var(--radius-md); }
</style>
